var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotoHealthWorkerMediumLightSkinTone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5171 54.712C21.9684 54.752 6.87793 58.8924 6.87793 69.0041V70.7378H66.1562V69.0041C66.1562 58.8867 51.0657 54.7463 36.5171 54.712Z",
    fill: "url(#paint0_radial_56_48033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4036 45.5414C55.6908 44.2468 56.5976 42.9294 58.1488 41.2983C60.6068 38.7091 63.2816 32.7037 60.7951 26.607C60.8122 26.5728 60.3046 25.5463 60.3217 25.512L59.3008 25.4607C58.9758 25.4151 47.7463 25.3923 36.5054 25.3923C25.2646 25.3923 14.0351 25.4151 13.7101 25.4607C13.7101 25.4607 12.1987 26.5728 12.2101 26.607C9.72927 32.7037 12.3983 38.7034 14.8564 41.2983C16.4019 42.9294 17.3087 44.2468 16.6015 45.5414C15.9115 46.8018 13.8583 46.9843 13.8583 46.9843C13.8583 46.9843 14.3317 48.2732 15.4723 48.969C16.5274 49.6134 17.8277 49.7617 18.7231 49.7845C18.7231 49.7845 22.2305 54.6379 31.4011 54.6379H41.6097C50.7804 54.6379 54.2878 49.7845 54.2878 49.7845C55.1832 49.7617 56.4835 49.6134 57.5386 48.969C58.6792 48.2732 59.1526 46.9843 59.1526 46.9843C59.1526 46.9843 57.0937 46.8018 56.4036 45.5414Z",
    fill: "#AB872F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4941 54.6322V49.2484L52.788 47.9595L54.2708 49.7845C54.2708 49.7845 50.7634 54.6379 41.5927 54.6379L36.4941 54.6322Z",
    fill: "url(#paint1_radial_56_48033)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2369 47.4291C51.796 43.7221 57.2082 42.3362 57.2082 42.3362L57.2139 42.3419C56.2729 43.5111 55.8452 44.5319 56.3984 45.5414C57.0885 46.8018 59.1416 46.9843 59.1416 46.9843C59.1416 46.9843 56.3413 49.4709 54.2369 47.4291Z",
    fill: "url(#paint2_radial_56_48033)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8064 26.607C63.2302 32.5098 60.6809 38.5893 58.2913 41.1557C57.9662 41.5093 56.5747 42.8724 56.2553 43.9617C56.2553 43.9617 50.8145 36.3708 49.1891 31.911C48.864 31.0099 48.5618 30.086 48.5219 29.1278C48.4933 28.4092 48.6017 27.5538 49.018 26.9435C49.5256 26.1964 60.5155 25.974 60.5155 25.974C60.5155 25.9797 60.8064 26.607 60.8064 26.607Z",
    fill: "url(#paint3_radial_56_48033)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2044 26.607C9.78627 32.5097 12.3356 38.5893 14.7195 41.15C15.0503 41.5036 16.4361 42.8666 16.7555 43.9559C16.7555 43.9559 22.1963 36.3651 23.8217 31.9052C24.1524 31.0041 24.449 30.0802 24.4889 29.1221C24.5174 28.4035 24.4091 27.548 23.9928 26.9378C23.4852 26.1907 22.8921 26.3903 22.0309 26.3903C20.3884 26.3903 13.1967 25.9683 12.6378 25.9683C12.6435 25.9797 12.2044 26.607 12.2044 26.607Z",
    fill: "url(#paint4_radial_56_48033)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5169 54.6322V49.2484L20.223 47.9595L18.7402 49.7845C18.7402 49.7845 22.2477 54.6379 31.4183 54.6379L36.5169 54.6322Z",
    fill: "url(#paint5_radial_56_48033)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7748 47.4291C21.2157 43.7221 15.8035 42.3362 15.8035 42.3362L15.7978 42.3419C16.7388 43.5111 17.1665 44.5319 16.6133 45.5414C15.9232 46.8018 13.8701 46.9843 13.8701 46.9843C13.8701 46.9843 16.6704 49.4709 18.7748 47.4291Z",
    fill: "url(#paint6_radial_56_48033)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3213 51.3757V63.3295C31.3213 66.3293 33.4314 68.7646 36.0321 68.7646H36.9731C39.5737 68.7646 41.6839 66.335 41.6839 63.3295V51.3757H31.3213Z",
    fill: "#C48E6A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0322 58.1738L32.2279 70.7207H41.005L42.9669 58.1738H30.0322Z",
    fill: "#81D4FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7014 54.8489C45.0776 55.0941 46.6574 55.385 46.6574 55.385L48.4425 59.5483L45.4483 62.0519L47.0623 65.5708L43.88 70.6979H39.9619L41.7014 54.8489Z",
    fill: "url(#paint7_linear_56_48033)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3163 54.8489C27.94 55.0941 26.3603 55.385 26.3603 55.385L24.5752 59.5483L27.5693 62.0519L25.9554 65.5708L29.1377 70.6979H33.0557L31.3163 54.8489Z",
    fill: "url(#paint8_linear_56_48033)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7861 59.5026C19.6815 59.035 20.7252 58.3506 21.21 57.9286C22.305 56.9762 24.8999 54.5238 26.8332 56.2519C28.9206 58.0826 26.7762 60.9683 25.9493 62.166C25.5386 62.7648 25.225 63.4264 24.9683 64.0994",
    stroke: "#03A9F4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9897 63.5063C16.7102 63.5519 16.408 63.6716 16.1114 63.3865C15.9175 63.1983 15.6723 62.6622 15.7407 62.2002C15.8091 61.7326 16.3281 61.5387 17.4345 61.0653C18.2957 60.7003 19.0884 60.3296 19.807 59.8448L18.7348 58.5103C18.7348 58.5103 17.4973 59.2061 16.8243 59.4684C15.6323 59.9247 14.275 60.4437 14.0526 61.9493C13.813 63.569 14.7027 64.721 15.3871 65.24C15.946 65.6677 16.4821 65.8731 17.0011 65.9073C17.8052 65.9586 18.3413 65.4339 18.3413 64.6241C18.3413 63.8142 17.5486 63.415 16.9897 63.5063Z",
    fill: "url(#paint9_linear_56_48033)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1184 66.6087C21.1127 66.8939 21.0385 67.2076 21.3636 67.4585C21.5803 67.6239 22.145 67.7893 22.5898 67.6581C23.0403 67.5212 23.1601 66.9851 23.4681 65.8217C23.7076 64.9206 23.9585 64.0766 24.335 63.2952L25.8064 64.1621C25.8064 64.1621 25.2931 65.4852 25.1334 66.1924C24.8539 67.4414 24.5346 68.8558 23.0746 69.2892C21.5062 69.7626 20.2344 69.0383 19.6242 68.4394C19.1223 67.9433 18.8428 67.4471 18.7345 66.9338C18.5691 66.1468 19.0139 65.5366 19.8124 65.4225C20.6108 65.3084 21.1298 66.0384 21.1184 66.6087Z",
    fill: "url(#paint10_linear_56_48033)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4238 53.4687C28.7832 53.5201 26.9012 54.866 26.1826 55.6987L27.4772 56.8165C27.4943 56.7994 28.8745 55.2538 31.4238 55.1854V53.4687ZM49.1947 58.4476C47.8089 55.3279 45.6645 54.1417 44.5125 53.714C43.4574 53.3204 42.4308 53.1608 41.678 53.098V54.8147C42.2939 54.8717 43.0981 55.0086 43.9193 55.3165C44.8204 55.653 46.5028 56.594 47.6321 59.1433C49.2175 62.7135 49.6168 63.6431 49.6225 63.6431L51.1908 62.9644C51.1908 62.9644 50.7916 62.0405 49.1947 58.4476Z",
    fill: "#03A9F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4424 69.044C53.6472 69.044 55.4346 67.2566 55.4346 65.0518C55.4346 62.847 53.6472 61.0596 51.4424 61.0596C49.2376 61.0596 47.4502 62.847 47.4502 65.0518C47.4502 67.2566 49.2376 69.044 51.4424 69.044Z",
    fill: "url(#paint11_linear_56_48033)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4424 67.3331C52.7023 67.3331 53.7236 66.3117 53.7236 65.0518C53.7236 63.7919 52.7023 62.7706 51.4424 62.7706C50.1825 62.7706 49.1611 63.7919 49.1611 65.0518C49.1611 66.3117 50.1825 67.3331 51.4424 67.3331Z",
    fill: "#9E9E9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.087 28.7628H20.9137C17.5546 28.7628 14.8057 31.6942 14.8057 35.2701C14.8057 38.8459 17.5546 41.7773 20.9137 41.7773H52.0813C55.4404 41.7773 58.1893 38.8459 58.1893 35.2701C58.1893 31.6942 55.4461 28.7628 52.087 28.7628Z",
    fill: "#C48E6A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4997 6.31531C26.5763 6.31531 17.3828 16.9288 17.3828 32.2075C17.3828 47.4006 26.8557 54.9116 36.4997 54.9116C46.1437 54.9116 55.6166 47.3949 55.6166 32.2018C55.6166 16.9288 46.4231 6.31531 36.4997 6.31531Z",
    fill: "#E0BB95"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2532 28.4149C30.7228 27.7135 29.5023 26.6983 27.1298 26.6983C24.7573 26.6983 23.5312 27.7192 23.0065 28.4149C22.7727 28.7229 22.8297 29.0822 22.9951 29.2989C23.1434 29.4985 23.5882 29.6867 24.0787 29.5213C24.5691 29.356 25.5273 28.8598 27.1298 28.8484C28.7324 28.8598 29.6905 29.356 30.181 29.5213C30.6715 29.6867 31.1163 29.5042 31.2646 29.2989C31.4243 29.0822 31.487 28.7229 31.2532 28.4149ZM49.9994 28.4149C49.469 27.7135 48.2485 26.6983 45.876 26.6983C43.5035 26.6983 42.2773 27.7192 41.7527 28.4149C41.5188 28.7229 41.5759 29.0822 41.7412 29.2989C41.8895 29.4985 42.3344 29.6867 42.8248 29.5213C43.3153 29.356 44.2734 28.8598 45.876 28.8484C47.4786 28.8598 48.4367 29.356 48.9272 29.5213C49.4177 29.6867 49.8625 29.5042 50.0108 29.2989C50.1705 29.0822 50.2332 28.7229 49.9994 28.4149Z",
    fill: "#AB872F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1241 36.4506C28.677 36.4506 29.9358 35.1484 29.9358 33.542C29.9358 31.9356 28.677 30.6334 27.1241 30.6334C25.5713 30.6334 24.3125 31.9356 24.3125 33.542C24.3125 35.1484 25.5713 36.4506 27.1241 36.4506Z",
    fill: "#5D4037"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8761 36.4506C47.4289 36.4506 48.6877 35.1484 48.6877 33.542C48.6877 31.9356 47.4289 30.6334 45.8761 30.6334C44.3233 30.6334 43.0645 31.9356 43.0645 33.542C43.0645 35.1484 44.3233 36.4506 45.8761 36.4506Z",
    fill: "#5D4037"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3023 43.4256C39.4887 44.5034 33.5289 44.5034 31.7153 43.4256C30.6716 42.8039 29.6051 43.7563 30.0386 44.7031C30.4663 45.6327 33.7114 47.7942 36.523 47.7942C39.3347 47.7942 42.5398 45.6327 42.9676 44.7031C43.3953 43.7563 42.3459 42.8039 41.3023 43.4256Z",
    fill: "#6D4C41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7011 38.8174C38.6384 38.7946 38.5814 38.7775 38.5186 38.7718H34.4808C34.4181 38.7775 34.3553 38.7946 34.2983 38.8174C33.9333 38.9657 33.7337 39.3421 33.9048 39.747C34.0759 40.1519 34.88 41.2812 36.4997 41.2812C38.1194 41.2812 38.9236 40.1462 39.0946 39.747C39.2657 39.3421 39.0661 38.9657 38.7011 38.8174Z",
    fill: "#C48E6A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.352 14.3225C57.9605 12.218 54.8409 9.39497 52.0406 9.20677C51.5901 6.5149 48.71 4.23365 45.9212 3.34966C38.3759 0.960053 33.4656 3.64052 30.8307 5.07771C30.2832 5.37427 26.7416 7.34185 24.2664 5.93318C22.7152 5.04919 22.7437 2.65958 22.7437 2.65958C22.7437 2.65958 17.8846 4.5131 19.5442 9.67443C17.8732 9.74286 15.6832 10.4501 14.5255 12.794C13.1453 15.5886 13.6358 17.9211 14.035 19.039C12.5978 20.2594 10.7899 22.8543 12.0275 26.2249C12.9628 28.7628 16.687 29.9319 16.687 29.9319C16.4246 34.5001 17.2744 37.3118 17.7249 38.4467C17.8048 38.6463 18.0842 38.6292 18.1356 38.4239C18.7002 36.1597 20.6278 28.2723 20.4339 26.8979C20.4339 26.8979 26.907 25.6147 33.0777 21.0693C34.3324 20.1454 35.6955 19.3583 37.1441 18.7823C44.8946 15.6969 46.5143 20.9609 46.5143 20.9609C46.5143 20.9609 51.8867 19.9286 53.5063 27.3883C54.1166 30.1829 54.5272 34.6598 54.8751 37.7908C54.8979 38.0133 55.2002 38.0589 55.2857 37.8536C55.8275 36.6103 56.9111 34.1465 57.1677 31.6315C57.259 30.7475 59.6429 29.5783 60.6695 25.7801C62.0439 20.7157 60.3615 15.8452 59.352 14.3225Z",
    fill: "#AB872F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.157 31.6543C57.2483 30.7703 59.6322 29.6012 60.6588 25.8029C60.7671 25.398 60.8584 24.9873 60.9439 24.5767C61.7766 19.9629 60.2823 15.7255 59.3527 14.3225C58.0638 12.3777 55.3035 9.82274 52.6858 9.29805C52.4577 9.26954 52.2352 9.24102 52.0242 9.22961C52.0242 9.22961 52.2124 10.4558 51.7163 11.431C51.0775 12.6971 49.7715 12.9994 49.7715 12.9994C56.5981 19.8317 56.1134 25.5463 57.157 31.6543Z",
    fill: "url(#paint12_radial_56_48033)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4789 4.21657C31.8515 4.51883 31.304 4.8211 30.825 5.07774C30.2775 5.3743 26.7358 7.34188 24.2607 5.93321C22.738 5.06633 22.738 2.75086 22.738 2.67102C22.0365 3.56641 19.9149 9.95961 26.1199 10.3873C28.7947 10.5698 30.4429 8.23727 31.4238 6.26399C31.7774 5.5454 32.3306 4.49602 32.4789 4.21657Z",
    fill: "url(#paint13_radial_56_48033)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1461 3.12155C49.3208 4.25077 51.3568 6.37804 52.0354 9.21249C52.2351 10.0451 52.4746 17.8128 37.6465 8.98437C32.1315 5.69937 33.6372 3.64624 34.2816 3.41241C36.8024 2.49991 40.4695 1.85546 45.1461 3.12155Z",
    fill: "url(#paint14_radial_56_48033)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7209 2.67101C22.7152 2.67672 22.7038 2.67672 22.6867 2.68812H22.681C22.1506 2.91054 17.9816 4.8439 19.5385 9.67445L23.9756 10.3873C20.0461 6.40656 22.738 2.65961 22.738 2.65961C22.738 2.65961 22.7266 2.66531 22.7209 2.67101Z",
    fill: "url(#paint15_radial_56_48033)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2823 10.1136L19.5391 9.67444C19.4307 9.67444 19.0657 9.70866 18.8661 9.73717C17.3205 9.95389 15.5012 10.7523 14.5146 12.794C13.4538 14.9955 13.4823 16.8832 13.7732 18.1436C13.8587 18.5656 14.0298 19.0447 14.0298 19.0447C14.0298 19.0447 15.3872 17.7558 18.6208 17.6702L22.2823 10.1136Z",
    fill: "url(#paint16_radial_56_48033)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8988 19.153C12.5472 20.3507 10.7279 23.0255 12.0681 26.3447C13.0776 28.8484 16.682 29.9319 16.682 29.9319C16.682 29.9434 17.4005 30.1601 17.7713 30.1601L18.6153 17.6702C16.8873 17.6702 15.2277 18.1892 14.1555 18.9363C14.1726 18.9534 13.8931 19.1359 13.8988 19.153Z",
    fill: "url(#paint17_radial_56_48033)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.582 70.4566) rotate(179.761) scale(42.7822 23.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8167 46.8534) scale(13.3561 6.56054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9729 44.8658) rotate(154.924) scale(3.94693 2.92806)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#BFA055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7432 33.7025) rotate(-94.2783) scale(17.3367 14.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.2694 33.7022) rotate(-85.7217) scale(17.3367 14.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1954 46.8534) rotate(180) scale(13.3561 6.56054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0409 44.8662) rotate(25.0761) scale(3.94693 2.92806)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#BFA055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_56_48033",
    x1: 44.201,
    y1: 66.5831,
    x2: 44.201,
    y2: 55.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_56_48033",
    x1: 28.8183,
    y1: 66.5831,
    x2: 28.8183,
    y2: 55.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_56_48033",
    x1: 19.3947,
    y1: 59.5933,
    x2: 14.0298,
    y2: 65.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_56_48033",
    x1: 24.4165,
    y1: 63.9551,
    x2: 19.0516,
    y2: 70.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_56_48033",
    x1: 50.1056,
    y1: 62.2276,
    x2: 53.171,
    y2: 68.7149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7756 24.5547) rotate(72.0851) scale(20.3216 15.0782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9645 2.39814) rotate(28.2026) scale(5.32854 6.31809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFA055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.8736 12.075) rotate(-157.19) scale(16.6643 9.3654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8248 7.2591) scale(4.89043 5.98246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1516 15.8916) rotate(-164.942) scale(9.17267 8.58395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_56_48033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.978 24.7483) rotate(7.83355) scale(9.63061 13.5326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#BFA055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA055"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoHealthWorkerMediumLightSkinTone);
export default __webpack_public_path__ + "static/media/noto_health-worker-medium-light-skin-tone.3bdb62a986773f44cc0e519f94b23213.svg";
export { ForwardRef as ReactComponent };